export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user',
    AGENCY: 'agency',
    ACCOUNT: 'account',
};
export const ALL = 'all';
export const PUBLIC = 'public';
export const PRIVATE = 'private';
export const ADMIN = 'admin';
export const PIXABAY = 'pixabay';
export const UNSPLASH = 'unsplash';
